import { combineStrings } from 'assets/utils/data/String';
import Model from 'models/Model';

export default class RefundPayee
  extends Model<Model.IRefundPayee>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IRefundPayee>
{
  id: number;
  firstName: string;
  lastName: string;
  readonly name?: string;

  phone: string;
  readonly phoneNumber?: string;

  email: string;

  taxExempt: boolean;

  streetAddress: string;
  city: string;
  provinceCode: string;
  postalCode: string;
  countryCode: string;
  readonly address?: string;

  paymentMethodCode: string;

  constructor(data: Partial<Model.IRefundPayee> | Utils.FormData<Model.IRefundPayee>, language?: Locale.Languages) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this?.name ?? this.id?.toString(),
      subtitle: this?.fullAddress,
    };
  }

  get fullAddress() {
    return combineStrings(', ', this.streetAddress, combineStrings(' ', this.postalCode, this.provinceCode));
  }
}
